import TopBar from './TopBar.container';

export default TopBar;
